<div class="dynamic-field form-button" [formGroup]="group">
    <button mat-raised-button [disabled]="config.disabled" type="submit" [ngClass]="config.class" (click)="config.function($event)" id="{{config.id}}">
        {{ config.label }}
    </button>
    </div>